<app-collapsible-box #address [title]="'MAIN_APP_ADRESSES.ADRESSE'">
	<div [formGroup]="addressForm" class="address-form">
		<span>
			<mat-form-field>
				<mat-label>Nr.</mat-label>
				<input formControlName="adressNo" matInput/>
			</mat-form-field>
		</span>
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.titel" | translate }}</mat-label>
				<input formControlName="title" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }}</mat-label>
				<input formControlName="lastName" matInput/>
			</mat-form-field>
			
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.vorname" | translate }}</mat-label>
				<input formControlName="firstName" matInput/>
			</mat-form-field>
		</span>
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.briefanrede" | translate }}</mat-label>
				<input formControlName="letterHead" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }}</mat-label>
				<input formControlName="salutation" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.zusatz" | translate }}</mat-label>
				<input formControlName="companyDescription" matInput/>
			</mat-form-field>
		</span>
		
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.plz" | translate }}</mat-label>
				<input formControlName="zip" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.ort" | translate }}</mat-label>
				<input formControlName="city" matInput/>
			</mat-form-field>
		</span>
		
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.strasse" | translate }}</mat-label>
				<input formControlName="street1" matInput/>
			</mat-form-field>
		</span>
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }}</mat-label>
				<input formControlName="email" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }}</mat-label>
				<input formControlName="phone03" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }}</mat-label>
				<input formControlName="phone01" matInput/>
			</mat-form-field>
		</span>
	
	</div>
</app-collapsible-box>

<app-collapsible-box #addressAdditional [title]="'MAIN_APP_ADRESSES.ADRESSERWEITERUNG'">
	<div [formGroup]="addressForm" class="address-form">
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.strasse2" | translate }}</mat-label>
				<input formControlName="street2" matInput/>
			</mat-form-field>
		</span>
		<span> <!--if country?-->
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.landKuerzel" | translate }}</mat-label>
				<input formControlName="countryISOShort" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.land" | translate }}</mat-label>
				<mat-select formControlName="country">
					<mat-option *ngFor="let land of (countries$ | async)" [value]="land">
						{{ land.isoNameNational }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.warnung" | translate }}</mat-label>
				<mat-select formControlName="adressStatus">
					<mat-option *ngFor="let adrState of (addressStatus$ | async)" [value]="adrState.id">
						{{ adrState.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>
		
		<span class="checkBoxShowName2OnAddressLine" style="flex-direction:column">
			<mat-label>{{ "MAIN_APP_ADRESSES.zusatzadresse" | translate }}</mat-label>
			<span>
				<mat-checkbox #name2onAddressLine (change)="setName2AsFirstAddressLine($event.checked)"></mat-checkbox>
				{{ "MAIN_APP_ADDRESS.ADDRESS_DETAIL.showName2onAddressLine" | translate }}
			</span>
		</span>
		
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.name2" | translate }}</mat-label>
				<input formControlName="lastName2" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.vorname2" | translate }}</mat-label>
				<input formControlName="firstName2" matInput/>
			</mat-form-field>
		</span>
		
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.titel2" | translate }}</mat-label>
				<input formControlName="title2" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }}</mat-label>
				<input formControlName="letterHead2" matInput/>
			</mat-form-field>
		</span>
		
		<span>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }}</mat-label>
				<input formControlName="email2" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }}</mat-label>
				<input formControlName="phone04" matInput/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }}</mat-label>
				<input formControlName="phone02" matInput/>
			</mat-form-field>
		</span>
	
	
	</div>
</app-collapsible-box>

<app-collapsible-box #addressPartners *ngIf="dataPartnerAddresses.length" [title]="'MAIN_APP_ADRESSES.ANSPRECHPARTNER'">
	<table [dataSource]="dataPartnerAddresses" class="mat-elevation-z8" mat-table>
		<ng-container matColumnDef="ha">
			<th *matHeaderCellDef mat-header-cell>HA</th>
			<td *matCellDef="let element" mat-cell>
				<mat-radio-button (change)="setAnsprechpartner(element)" [checked]="element.hauptAnsprechpartner == 1" [name]="element.adresseID" [value]="element.adresseID"></mat-radio-button>
			</td>
		</ng-container>
		
		<ng-container matColumnDef="name">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.name" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.name }}</td>
		</ng-container>
		
		<ng-container matColumnDef="vorname">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.vorname" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.vorname }}</td>
		</ng-container>
		
		<ng-container matColumnDef="zuhanden">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.zuhanden" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.zuhanden }}</td>
		</ng-container>
		
		<ng-container matColumnDef="briefanrede">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.briefanrede" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				{{ element.briefanrede }}
			</td>
		</ng-container>
		
		<ng-container matColumnDef="telefon">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.telefon" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				<a href="tel:{{ element.phone01 }}">{{ element.telefon }}</a>
			</td>
		</ng-container>
		
		<ng-container matColumnDef="natel">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.natel" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				<a href="tel:{{ element.phone01 }}">{{ element.natel }}</a>
			</td>
		</ng-container>
		
		<ng-container matColumnDef="email">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_ADRESSES.email" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				<a href="mailto:{{ element.email }}">{{ element.email }}</a>
			</td>
		</ng-container>
		
		<ng-container matColumnDef="pers">
			<th *matHeaderCellDef mat-header-cell style="text-align: center">
				{{ "MAIN_APP_ADRESSES.pers" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell style="text-align: center">
				<mat-checkbox (change)="setAnsprechPersoenlich(element, $event.checked)" [checked]="element.pers == 1"></mat-checkbox>
			</td>
		</ng-container>
		
		<ng-container matColumnDef="menuAP">
			<th *matHeaderCellDef mat-header-cell style="text-align: center"></th>
			<td *matCellDef="let element" mat-cell style="text-align: center">
				<button [matMenuTriggerFor]="anpaMenu" aria-label="Example icon-button with a menu" mat-icon-button>
					<mat-icon>more_horiz</mat-icon>
				</button>
				<mat-menu #anpaMenu="matMenu">
					<button (click)="editAnsprechpartner(element)" mat-menu-item>
						<mat-icon>edit</mat-icon>
						<span>{{ "MAIN_APP_ADRESSES.bearbeiten" | translate }}</span>
					</button>
					<button (click)="delAnsprechpartner(element)" mat-menu-item>
						<mat-icon>delete</mat-icon>
						<span>{{ "MAIN_APP_ADRESSES.löschen" | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		
		<tr *matHeaderRowDef="displayedAnsprechColumns" mat-header-row></tr>
		<tr *matRowDef="let row; columns: displayedAnsprechColumns" mat-row></tr>
	</table>

</app-collapsible-box>

<app-collapsible-box #addressObjects *ngIf="dataObjects.length" [title]="'MAIN_APP_ADRESSES.OBJEKTLISTE'">
	<table [dataSource]="dataObjects" class="mat-elevation-z8" mat-table>
		<ng-container *ngFor="let dispCol of displayedObjListColumns; let colIndex = index" matColumnDef="{{ dispCol }}">
			<th *matHeaderCellDef [ngClass]="dispCol" mat-header-cell>{{ dispCol }}</th>
			<ng-container *ngIf="colIndex === objektListTypeColIndex">
				<td *matCellDef="let element" [ngClass]="dispCol" mat-cell>
					<ng-container *ngIf="element.objectType == 1">
						<img alt="img" src="/assets/tv_icons/building_storage.png"/>
					</ng-container>
					
					<ng-container *ngIf="element.objectType == 2">
						<img alt="img" src="/assets/tv_icons/book.png"/>
					</ng-container>
					
					<ng-container *ngIf="element.objectType == 3">
						<img alt="img" src="/assets/tv_icons/folder_open.png"/>
					</ng-container>
					
					<ng-container *ngIf="element.objectType == 4">
						<img alt="img" src="/assets/tv_icons/book_open.png"/>
					</ng-container>
				</td>
			</ng-container>
			<ng-container *ngIf="colIndex !== objektListTypeColIndex">
				<td *matCellDef="let element" [ngClass]="dispCol" mat-cell>
					{{ getObjektListValue(element, dispCol) }}
				</td>
			</ng-container>
		</ng-container>
		<tr *matHeaderRowDef="displayedObjListColumns" mat-header-row></tr>
		<tr (click)="openObjekt(row)" *matRowDef="let row; columns: displayedObjListColumns" mat-row></tr>
	</table>
</app-collapsible-box>
